export default {
  computed: {
    shortcuts() {
      return this.getShortcuts(this.shortcutKeys);
    },
  },
  data() {
    return {
      shortcutKeys: [],
    };
  },
  methods: {
    getShortcuts(keys) {
      const shortcuts = [];
      keys.forEach((key) => {
        const method = key.split(':')[0];
        const params = key.split(':')[1];
        shortcuts.push(this[method](params));
      });
      return shortcuts;
    },
    today() {
      return {
        text: 'Hoy',
        onClick(picker) {
          picker.$emit('pick', new Date());
        },
      };
    },
    lastWeek() {
      return {
        text: `Ult. Semana`,
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        },
      };
    },
    nextWeek() {
      return {
        text: `Próx. Semana`,
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        },
      };
    },
    lastMonths(months) {
      return {
        text: +months === 1 ? `Ultimo Mes` : `Ult. ${months} Meses`,
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 30 * months);
          picker.$emit('pick', date);
        },
      };
    },
    nextMonths(months) {
      return {
        text: +months === 1 ? `Próximo Mes` : `Próx. ${months} Meses`,
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * months);
          picker.$emit('pick', date);
        },
      };
    },
    lastYear() {
      return {
        text: 'Ultimo Año',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
          picker.$emit('pick', date);
        },
      };
    },
    nextYear() {
      return {
        text: 'Próximo Año',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
          picker.$emit('pick', date);
        },
      };
    },
  },
  watch: {},
};
